import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, RouterLink, RouterLinkActive, RouterModule, RouterOutlet } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { FooterComponent } from '../components/footer/footer.component';

@Component({
  selector: 'app-terms-shell',
  standalone: true,
  imports: [
    RouterOutlet,
    RouterModule,
    RouterLink,
    RouterLinkActive,
    AngularSvgIconModule,
    FooterComponent,
    NgTemplateOutlet,
    NgClass,
  ],
  templateUrl: './terms-shell.component.html',
  styleUrl: './terms-shell.component.scss',
})
export class TermsShellComponent {
  constructor(private activatedroute: ActivatedRoute) {}

  isOpened: boolean = false;

  toggle() {
    this.isOpened = !this.isOpened;
  }
}
